const DrugData = [
    {
        // 비타민 A 완료
        "id": 1,
        "company": "솔가", 
        "type": "비타민A",
        "name": "드라이 비타민A",
        "image": "images/drug-1.png",
        "explain": "지방에 잘 녹는 지용성 비타민으로, 식후 복용을 추천드립니다.", 

        "modalExplain": "비타민 A는 눈의 망막 색소의 구성성분으로서, 눈의 기능을 도와 시력을 유지시키는 역할을 합니다.그 외에 도 세포의 분화와 성장, 뼈와 치아 발달, 장기의 형성과 기능 발휘, 피부나 점막 등 상피조직의 유지에도 관련이 있습니다.식품으로는 간, 계란 노른자, 버터, 우유 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-liver.png",
        "modalImage2": "images/food-egg.png",
        "modalImage3": "images/food-butter.png",
        "modalImage4": "images/food-milk.png",

        "selectType": "비타민",
        "selectExplain": "눈건강,뼈건강"
    },
    {
        "id": 2,
        "company": "LG생활건강",
        "type": "비타민A",
        "name": "비타민A 츄어블",
        "image": "images/drug-2.png",
        "explain": "지방에 잘 녹는 지용성 비타민으로, 식후 복용을 추천드립니다.", 

        "modalExplain": "비타민 A는 눈의 망막 색소의 구성성분으로서, 눈의 기능을 도와 시력을 유지시키는 역할을 합니다.그 외에 도 세포의 분화와 성장, 뼈와 치아 발달, 장기의 형성과 기능 발휘, 피부나 점막 등 상피조직의 유지에도 관련이 있습니다.식품으로는 간, 계란 노른자, 버터, 우유 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-liver.png",
        "modalImage2": "images/food-egg.png",
        "modalImage3": "images/food-butter.png",
        "modalImage4": "images/food-milk.png",

        "selectType": "비타민",
        "selectExplain": "눈건강,뼈건강"
    },
    {
        "id": 3,
        "company": "나우푸드",
        "type": "비타민B1",
        "name": "비타민 B1",
        "image": "images/drug-3.png",
        "explain": "물에 잘 녹는 수용성 비타민으로, 식전 복용을 추천드립니다. 밤에는 수면 방해로 인해 복용을 권장하지 않습니다.",

        "modalExplain": "비타민 B1은 체내 에너지 생산에 중요한 역할을 하는 영양소입니다. 효능으로는 인지 건강, 운동능력 증진, 체중 조절, 심장 건강 등이 있습니다.식품으로는 싱싱한 고기, 계란 노른자, 우유, 곡식, 채소, 과일 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-meat.png",
        "modalImage2": "images/food-egg.png",
        "modalImage3": "images/food-milk.png",
        "modalImage4": "images/food-fruits.png",

        "selectType": "비타민",
        "selectExplain": "피로회복"
    },
    {
        "id": 4,
        "company": "Nutricost",
        "type": "비타민B1",
        "name": "Vitamin B1",
        "image": "images/drug-4.png",
        "explain": "물에 잘 녹는 수용성 비타민으로, 식전 복용을 추천드립니다. 밤에는 수면 방해로 인해 복용을 권장하지 않습니다.",

        "modalExplain": "비타민 B1은 체내 에너지 생산에 중요한 역할을 하는 영양소입니다.효능으로는 인지 건강, 운동능력 증진, 체중 조절, 심장 건강 등이 있습니다.식품으로는 싱싱한 고기, 계란 노른자, 우유, 곡식, 채소, 과일 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-meat.png",
        "modalImage2": "images/food-egg.png",
        "modalImage3": "images/food-milk.png",
        "modalImage4": "images/food-fruits.png",

        "selectType": "비타민",
        "selectExplain": "피로회복"
    },
    {
        // 아연 완료
        "id": 5,
        "company": "뉴트리메이드",
        "type": "아연",
        "name": "아연",
        "image": "images/drug-5.png",
        "explain": "지방에 잘 녹는 지용성 영양소로, 식후 약 2시간이 지난 식후 복용을 추천드립니다. 저녁보다는 아침에 섭취하는 것을 추천드립니다.",

        "modalExplain": "아연은 여러가지 생리적 기능을 조절하고 세포의 생존 및 성장에 필수적인 역할을 합니다.근육의 탄력성 및 회복력을 향상시키는 데에 도움을 주며, 근육 생리학적으로 중요한 아미노산 중 하나인 아르지닌은 아연에 의해 상당히 규정되기 때문에 근육 분해 및 회복 속도를 조절하는 데에도 영향을 줍니다.혈중 트림에토판 수치를 높이고, 생체에서 단백질의 합성을 촉진시켜 근관환 요구를 충족시킵니다.이러한 과정에서 근육 손상이 최소화되고, 근육 성장이 증진되며, 근력의 유지 능력이 향상됩니다.마지막으로, 아연은 성장기 아동들의 조직 및 뼈 건강에도 중요한 영향을 미칩니다.세포 분열과 성장을 조절하여 성장하는 아이들에게 필요한 영양성분을 제공합니다.식품으로는 고기, 견과류, 콩, 해산물 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-meat.png",
        "modalImage2": "images/food-nuts.png",
        "modalImage3": "images/food-bean.png",
        "modalImage4": "images/food-seafood.png",

        "selectType": "아연",
        "selectExplain": "뼈건강"
    },
    {
        "id": 6,
        "company": "웰러스",
        "type": "아연",
        "name": "바른 아연",
        "image": "images/drug-6.png",
        "explain": "지방에 잘 녹는 지용성 영양소로, 식후 약 2시간이 지난 식후 복용을 추천드립니다. 저녁보다는 아침에 섭취하는 것을 추천드립니다.",

        "modalExplain": "아연은 여러가지 생리적 기능을 조절하고 세포의 생존 및 성장에 필수적인 역할을 합니다.근육의 탄력성 및 회복력을 향상시키는 데에 도움을 주며, 근육 생리학적으로 중요한 아미노산 중 하나인 아르지닌은 아연에 의해 상당히 규정되기 때문에 근육 분해 및 회복 속도를 조절하는 데에도 영향을 줍니다.혈중 트림에토판 수치를 높이고, 생체에서 단백질의 합성을 촉진시켜 근관환 요구를 충족시킵니다.이러한 과정에서 근육 손상이 최소화되고, 근육 성장이 증진되며, 근력의 유지 능력이 향상됩니다.마지막으로, 아연은 성장기 아동들의 조직 및 뼈 건강에도 중요한 영향을 미칩니다.세포 분열과 성장을 조절하여 성장하는 아이들에게 필요한 영양성분을 제공합니다.식품으로는 고기, 견과류, 콩, 해산물 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-meat.png",
        "modalImage2": "images/food-nuts.png",
        "modalImage3": "images/food-bean.png",
        "modalImage4": "images/food-seafood.png",

        "selectType": "아연",
        "selectExplain": "뼈건강"
    },
    {
        // 비타민 D 완료
        "id": 7,
        "company": "Doctor's Best",
        "type": "비타민D",
        "name": "비타민 D3",
        "image": "images/drug-7.png",
        "explain": "지방에 잘 녹는 지용성 비타민으로, 식후 복용을 추천드립니다. 밤에는 수면 방해로 인해 복용을 권장하지 않습니다.",

        "modalExplain": "비타민 D는 신체가 칼슘을 흡수하도록 도와주기 때문에 건강한 뼈, 근육 및 치아에 중요한 영양소입니다.호르몬 인슐린과 글루카곤의 적절한 기능을 도와 체내에서의 적절한 포도당 흡수를 유지할 때 도움을 주어 당뇨병 위험을 감소시킵니다.신체의 면역력을 높여 암, 관절염, 파킨슨병 등 퇴행성 질환의 위험을 감소시킵니다.우을증과 기분 변화를 유발할 수 있어 기분을 크게 향상시키고, 정신 검강을 증진 시킬 수 있습니다.체중 감량에 도움을 주는 세로토닌과 테스토스테론의 수치를 증가시키기 때문에 지방 세포의 저장과 형성을 변화시켜 체중 감소를 촉진합니다.식품으로는 간, 계란 노른자, 고등어 등 기름기 있는 생선 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-liver.png",
        "modalImage2": "images/food-egg.png",
        "modalImage3": "images/food-fish.png",
        "modalImage4": "images/food-sun.png",

        "selectType": "비타민",
        "selectExplain": "뼈건강"
    }, 
    {
        "id": 8,
        "company": "뉴트리코어",
        "type": "비타민D",
        "name": "비타민 D",
        "image": "images/drug-8.png",
        "explain": "지방에 잘 녹는 지용성 비타민으로, 식후 복용을 추천드립니다. 밤에는 수면 방해로 인해 복용을 권장하지 않습니다.",

        "modalExplain": "비타민 D는 신체가 칼슘을 흡수하도록 도와주기 때문에 건강한 뼈, 근육 및 치아에 중요한 영양소입니다.호르몬 인슐린과 글루카곤의 적절한 기능을 도와 체내에서의 적절한 포도당 흡수를 유지할 때 도움을 주어 당뇨병 위험을 감소시킵니다.신체의 면역력을 높여 암, 관절염, 파킨슨병 등 퇴행성 질환의 위험을 감소시킵니다.우을증과 기분 변화를 유발할 수 있어 기분을 크게 향상시키고, 정신 검강을 증진 시킬 수 있습니다.체중 감량에 도움을 주는 세로토닌과 테스토스테론의 수치를 증가시키기 때문에 지방 세포의 저장과 형성을 변화시켜 체중 감소를 촉진합니다.식품으로는 간, 계란 노른자, 고등어 등 기름기 있는 생선을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-liver.png",
        "modalImage2": "images/food-egg.png",
        "modalImage3": "images/food-fish.png",
        "modalImage4": "images/food-sun.png",

        "selectType": "비타민",
        "selectExplain": "뼈건강"
    },
    {
        // 비타민 C 완료
        "id": 9,
        "company": "아이허브",
        "type": "비타민C",
        "name": "비타민C 구미젤리",
        "image": "images/drug-9.png",
        "explain": "지방에 잘 녹는 지용성 비타민으로, 식전 복용 시 위장 장애를 일으킬 수 있기 때문에 식후 복용을 추천드립니다.",

        "modalExplain": "비타민 C는 수용성 비타민의 한 종류입니다.귤과 같은 과일이나 여러 채소에 풍부하게 들어있고 정제하여 건강 보조 식품으로 판매되기도 하고, 괴혈병의 예방 및 치료제로 쓰이기도 합니다.식품으로는 귤, 키위, 감자, 채소 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-orange.png",
        "modalImage2": "images/food-kiwi.png",
        "modalImage3": "images/food-potato.png",
        "modalImage4": "images/food-vegetable.png",

        "selectType": "비타민",
        "selectExplain": "피로회복"
    },
    {
        "id": 10,
        "company": "고려은단",
        "type": "비타민C",
        "name": "비타민C 1000",
        "image": "images/drug-10.png",
        "explain": "지방에 잘 녹는 지용성 비타민으로, 식전 복용 시 위장 장애를 일으킬 수 있기 때문에 식후 복용을 추천드립니다.",

        "modalExplain": "비타민 C는 수용성 비타민의 한 종류입니다.귤과 같은 과일이나 여러 채소에 풍부하게 들어있고 정제하여 건강 보조 식품으로 판매되기도 하고, 괴혈병의 예방 및 치료제로 쓰이기도 합니다.식품으로는 귤, 키위, 감자, 채소 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-orange.png",
        "modalImage2": "images/food-kiwi.png",
        "modalImage3": "images/food-potato.png",
        "modalImage4": "images/food-vegetable.png",

        "selectType": "비타민",
        "selectExplain": "피로회복"
    },
    {
        // 루테인 완료
        "id": 11,
        "company": "프롬바이오",
        "type": "루테인",
        "name": "루테인",
        "image": "images/drug-11.png",
        "explain": "지방에 잘 녹는 지용성 영양소로, 지방 성분의 식사와 함께 하면 흡수가 좋습니다. 따라서 식후 복용을 추천드립니다.",

        "modalExplain": "루테인은 외부 공격으로 눈을 보호하고 회복시켜 눈 건강에 도움을 줍니다.몸에 누적되는 항산화 성분으로 피부에도 존재하여 먹는 선크림 역할을 하기 때문에 자외선과 외부 스트레스로부터 피부를 보호해 건강에 도움을 줍니다.황반 색소 밀도를 늘려 뇌 기능 개선에도 도움을 주며, 특히 뇌를 구성하는 백질에 긍정적인 영향을 줍니다.식품으로는 시금치, 케일, 브로콜리, 노란 고추, 각종 야채와 과일 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-spinach.png",
        "modalImage2": "images/food-kale.png",
        "modalImage3": "images/food-broccoli.png",
        "modalImage4": "images/food-fruits.png",

        "selectType": "루테인",
        "selectExplain": "눈건강"
    },
    {
        "id": 12,
        "company": "피토틱스",
        "type": "루테인",
        "name": "루테인아스타잔틴+",
        "image": "images/drug-12.png",
        "explain": "지방에 잘 녹는 지용성 영양소로, 지방 성분의 식사와 함께 하면 흡수가 좋습니다. 따라서 식후 복용을 추천드립니다.",

        "modalExplain": "루테인은 외부 공격으로 눈을 보호하고 회복시켜 눈 건강에 도움을 줍니다.몸에 누적되는 항산화 성분으로 피부에도 존재하여 먹는 선크림 역할을 하기 때문에 자외선과 외부 스트레스로부터 피부를 보호해 건강에 도움을 줍니다.황반 색소 밀도를 늘려 뇌 기능 개선에도 도움을 주며, 특히 뇌를 구성하는 백질에 긍정적인 영향을 줍니다.식품으로는 시금치, 케일, 브로콜리, 노란 고추, 각종 야채와 과일 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-spinach.png",
        "modalImage2": "images/food-kale.png",
        "modalImage3": "images/food-broccoli.png",
        "modalImage4": "images/food-fruits.png",
        
        "selectType": "루테인",
        "selectExplain": "눈건강"
    },
    {
        // 칼슘 완료
        "id": 13,
        "company": "NaturesPlus",
        "type": "칼슘",
        "name": "칼슘",
        "image": "images/drug-13.png",
        "explain": "지방에 잘 녹는 지용성 영양소로, 식후 복용을 추천드립니다. 근육 신경의 안정을 도와 숙면에 도움이 되기 때문에 저녁 식사 후를 추천드립니다.",

        "modalExplain": "칼슘은 튼튼한 뼈와 치아를 형성하는 데 중요한 역할을 합니다.근육 성장, 건강한 심장박동 유지, 신경계 기능을 위한 영양을 공급하며 결핍으로 인한 근육 경련을 방지하는 데 도움을 줍니다.건강한 에너지 생산, 필수 효소 활동 및 정상적인 뇌 세포막 기능에 관여합니다.식품으로는 간, 계란노른자, 버터, 우류, 치즈 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-liver.png",
        "modalImage2": "images/food-egg.png",
        "modalImage3": "images/food-butter.png",
        "modalImage4": "images/food-milk.png",

        "selectType": "칼슘/마그네슘",
        "selectExplain": "뼈건강"
    },
    {
        "id": 14,
        "company": "Source Naturals",
        "type": "칼슘",
        "name": "칼슘",
        "image": "images/drug-14.png",
        "explain": "지방에 잘 녹는 지용성 영양소로, 식후 복용을 추천드립니다. 근육 신경의 안정을 도와 숙면에 도움이 되기 때문에 저녁 식사 후를 추천드립니다.",

        "modalExplain": "칼슘은 튼튼한 뼈와 치아를 형성하는 데 중요한 역할을 합니다.근육 성장, 건강한 심장박동 유지, 신경계 기능을 위한 영양을 공급하며 결핍으로 인한 근육 경련을 방지하는 데 도움을 줍니다.건강한 에너지 생산, 필수 효소 활동 및 정상적인 뇌 세포막 기능에 관여합니다.식품으로는 간, 계란노른자, 버터, 우류, 치즈 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-liver.png",
        "modalImage2": "images/food-egg.png",
        "modalImage3": "images/food-butter.png",
        "modalImage4": "images/food-milk.png",

        "selectType": "칼슘/마그네슘",
        "selectExplain": "뼈건강"
    },
    {
        // 마그네슘 완료
        "id": 15,
        "company": "프리미엄",
        "type": "마그네슘",
        "name": "마그네슘 400",
        "image": "images/drug-15.png",
        "explain": "지방에 잘 녹는 지용성 영양소로, 식후 복용을 추천드립니다. 수면에 도움이 될 수 있도록 저녁 식사 후에 복용을 추천합니다.",

        "modalExplain": "마그네슘은 신경 자극 전달을 조절해 신경의 기능을 유지시키고, 근육의 수축, 이완 작용을 통해 근육의 기능을 유지합니다.신경 및 근육의 세포막 전위의 유지와 신경근 연접부에서의 충격전도에도 필수적인 역할을 합니다.신경과 근육 기능을 유지하고 싶은 분, 에너지 대사가 필요한 성장기 어린이, 불규칙한 식습관 및 유해환경에 노출된 현대인들에게 추천합니다.식품으로는 견과류, 해산물, 유제품, 초콜릿 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-nuts.png",
        "modalImage2": "images/food-seafood.png",
        "modalImage3": "images/food-dailyproduct.png",
        "modalImage4": "images/food-chocolate.png",

        "selectType": "칼슘/마그네슘",
        "selectExplain": "뼈건강"
    },
    {
        "id": 16,
        "company": "21st Century",
        "type": "마그네슘",
        "name": "마그네슘",
        "image": "images/drug-16.png",
        "explain": "지방에 잘 녹는 지용성 영양소로, 식후 복용을 추천드립니다. 수면에 도움이 될 수 있도록 저녁 식사 후에 복용을 추천합니다.",

        "modalExplain": "마그네슘은 신경 자극 전달을 조절해 신경의 기능을 유지시키고, 근육의 수축, 이완 작용을 통해 근육의 기능을 유지합니다.신경 및 근육의 세포막 전위의 유지와 신경근 연접부에서의 충격전도에도 필수적인 역할을 합니다.신경과 근육 기능을 유지하고 싶은 분, 에너지 대사가 필요한 성장기 어린이, 불규칙한 식습관 및 유해환경에 노출된 현대인들에게 추천합니다.식품으로는 견과류, 해산물, 유제품, 초콜릿 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-nuts.png",
        "modalImage2": "images/food-seafood.png",
        "modalImage3": "images/food-dailyproduct.png",
        "modalImage4": "images/food-chocolate.png",
        
        "selectType": "칼슘/마그네슘",
        "selectExplain": "뼈건강"
    },
    {
        // 철분제 완료
        "id": 17,
        "company": "닥터라인",
        "type": "철분제",
        "name": "헤모퀸즈 철분제",
        "image": "images/drug-17.png",
        "explain": "물에 잘 녹는 수용성 영양소로, 식전 복용을 추천드립니다. 흡수율을 높이기 위해 저녁 식사 전에 복용을 추천드립니다.",

        "modalExplain": "철분제는 철분 결핍에 의한 탈모 증상, 무기력증, 만성 출혈, 빈혈을 예방합니다.ADHD 과잉 행동 증상 개선, 호흡 곤란 문제, 피로 회복을 개선하는 데에도 효과적입니다.식품으로는 고기, 닭고기, 콩, 생선 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-meat.png",
        "modalImage2": "images/food-chicken.png",
        "modalImage3": "images/food-bean.png",
        "modalImage4": "images/food-fish.png",

        "selectType": "철분제/오메가3",
        "selectExplain": "임산부추천"
    }, 
    {
        "id": 18,
        "company": "올바른",
        "type": "철분제",
        "name": "프리미엄 철분제",
        "image": "images/drug-18.png",
        "explain": "물에 잘 녹는 수용성 영양소로, 식전 복용을 추천드립니다. 흡수율을 높이기 위해 저녁 식사 전에 복용을 추천드립니다.",

        "modalExplain": "철분제는 철분 결핍에 의한 탈모 증상, 무기력증, 만성 출혈, 빈혈을 예방합니다.ADHD 과잉 행동 증상 개선, 호흡 곤란 문제, 피로 회복을 개선하는 데에도 효과적입니다.식품으로는 고기, 닭고기, 콩, 생선 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-meat.png",
        "modalImage2": "images/food-chicken.png",
        "modalImage3": "images/food-bean.png",
        "modalImage4": "images/food-fish.png",

        "selectType": "철분제/오메가3",
        "selectExplain": "임산부추천"
    },
    {
        // 오메가3 완료
        "id": 19,
        "company": "트루포뮬러",
        "type": "오메가3",
        "name": "제일메가 오메가3",
        "image": "images/drug-19.png",
        "explain": "지방에 잘 녹는 지용성 영양소로, 식후 복용을 추천드립니다. 향산화 효과가 22시~2시 사이에 극대화되기 때문에, 저녁 식사 후에 복용을 추천드립니다.",

        "modalExplain": "오메가3는 우리 몸에 꼭 필요하지만 자체적으로 생산되지 않는 필수 지방산으로서 불포화지방산의 한 종류입니다.세포막을 구성하는 주요 성분이며, 염증을 억제하는 기능과 세포에 산소를 원활하게 해주는 역할도 합니다.심혈관 질환을 예방할 뿐만 아니라 염증 감소에 효과적이라 천식이나 만성염증 완화에 좋으며, 우울증이나 치매 예방에도 도움을 줍니다.오메가3 건강식품을 복용하는 것이 좋은 예는 심장에 좋은 고밀도 콜레스테롤의 수치가 낮은 경우, 등푸른생선에 알레르기가 있어 식품으로 섭취하지 못하는 경우, 혈관질환자와 흡연자 중에서 아스피린 복용이 어려운 경우, 생선 속 수은을 피해야 하는 임산부와 어린이, 중성지방 수치가 높은 경우, 혈당 수치가 높은 경우입니다.식품으로는 식물성 오일, 견과류, 해조류, 생선 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-oil.png",
        "modalImage2": "images/food-nuts.png",
        "modalImage3": "images/food-seaweed.png",
        "modalImage4": "images/food-fish.png",

        "selectType": "철분제/오메가3",
        "selectExplain": "혈관건강"
    },
    {
        "id": 20,
        "company": "나우푸드",
        "type": "오메가3",
        "name": "오메가3",
        "image": "images/drug-20.png",
        "explain": "지방에 잘 녹는 지용성 영양소로, 식후 복용을 추천드립니다. 향산화 효과가 22시~2시 사이에 극대화되기 때문에, 저녁 식사 후에 복용을 추천드립니다.",

        "modalExplain": "오메가3는 우리 몸에 꼭 필요하지만 자체적으로 생산되지 않는 필수 지방산으로서 불포화지방산의 한 종류입니다.세포막을 구성하는 주요 성분이며, 염증을 억제하는 기능과 세포에 산소를 원활하게 해주는 역할도 합니다. 심혈관 질환을 예방할 뿐만 아니라 염증 감소에 효과적이라 천식이나 만성염증 완화에 좋으며, 우울증이나 치매 예방에도 도움을 줍니다.오메가3 건강식품을 복용하는 것이 좋은 예는 심장에 좋은 고밀도 콜레스테롤의 수치가 낮은 경우, 등푸른생선에 알레르기가 있어 식품으로 섭취하지 못하는 경우, 혈관질환자와 흡연자 중에서 아스피린 복용이 어려운 경우, 생선 속 수은을 피해야 하는 임산부와 어린이, 중성지방 수치가 높은 경우, 혈당 수치가 높은 경우입니다.식품으로는 식물성 오일, 견과류, 해조류, 생선 등을 통해 섭취가 가능합니다.",
        "modalImage1": "images/food-oil.png",
        "modalImage2": "images/food-nuts.png",
        "modalImage3": "images/food-seaweed.png",
        "modalImage4": "images/food-fish.png",

        "selectType": "철분제/오메가3",
        "selectExplain": "혈관건강"
    }
]

export default DrugData;